import { createReducer, on } from '@ngrx/store';
import { MaintenanceApiActions } from '../../actions/maintenance-api.action';
import { IError } from 'src/app/core/models/general.model';
import { DEFAULT_ERROR_MESSAGE } from 'src/app/shared/constants/error.constants';

export interface MaintenanceApiState {
  isMaintenanceActive: boolean;
  errorMaintenanceBanner: IError | null;
}

export const initialState: MaintenanceApiState = {
  isMaintenanceActive: false,
  errorMaintenanceBanner: null,
};

export const reducer = createReducer(
  initialState,
  on(MaintenanceApiActions.getMaintenanceFlag, (state, action) => {
    return {
      ...state,
      isMaintenanceActive: false,
      errorMaintenanceBanner: null,
    };
  }),
  on(MaintenanceApiActions.getMaintenanceFlagSuccess, (state, action) => {
    return {
      ...state,
      isMaintenanceActive: action.isMaintenanceActive,
    };
  }),
  on(MaintenanceApiActions.getMaintenanceFlagFailure, (state, action) => {
    return {
      ...state,
      isMaintenanceActive: false,
      errorMaintenanceBanner: action.error?.error || DEFAULT_ERROR_MESSAGE,
    };
  })
);
